module.exports = __webpack_public_path__ + "img/box_stopped.a136ba87.svg";